module.exports = {
      id: "ic-basket-normal-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-basket-normal-usage",
      toString: function () {
        return this.url;
      }
    }